import { FeatureModuleAuth } from '@core/types';
import { createReducer, on } from '@ngrx/store';
import { getUserEntitlementsError, setUserEntitlements } from './entitlements.actions';

export const ENTITLEMENTS_FEATURE_KEY = 'platform-entitlements';

export interface IEntitlementsState {
    data?: FeatureModuleAuth[];
}

const entitlementsInitialState: IEntitlementsState = {
    data: undefined
};

export const authReducer = createReducer(
    entitlementsInitialState,
    // Set user entitlements
    on(setUserEntitlements, (state, data) => ({
        ...state,
        data: data.getUserAuth
    })),
    on(getUserEntitlementsError, state => ({
        ...state,
        data: undefined
    }))
);
